import React, { useState, useRef } from 'react'; //import React Component
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { cloudStore, storage } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc, query, collection, where, getDocs } from 'firebase/firestore';

export function AddProduct() {
    //Collect all the data from input
    const [proname, setproname] = useState('');
    const [prointro, setprointro] = useState('');
    const [proprice, setproprice] = useState('');
    const [pic, setpic] = useState('');
    const [stock, setstock] = useState('');
    const [brand, setbrand] = useState("")
    const [otherCate, setotherCate] = useState("")
    const [tag, settag] = useState("")
    const imageRef = useRef("")
    const metadata = {
        contentType: "image/jpeg"
    }; //Image type

    //Set value
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        const image = imageRef.current;
        if (id === "propic") {
            if (image.value.length > 0) {
                document.getElementsByTagName("label")[0].style.color = "black"
            }
            var divsToRemove = document.querySelectorAll(".resize");
            if (divsToRemove.length > 0) {
                for (var i = 0; i < divsToRemove.length; i++) {
                    divsToRemove[i].parentNode.removeChild(divsToRemove[i]);
                }
            }
            if (image.value.length !== 0) {
                setpic(image.files[0]);
                let imgName = image.files[0].name.split(".")[0];
                const tempo = ref(storage, "Tempo_forAddWelcome/" + imgName);
                const uploadTask = uploadBytesResumable(tempo, image.files[0], metadata)
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        const img_tips = document.createElement("div");
                        var text = document.createTextNode('Upload is ' + progress.toFixed(2) + '% done');
                        img_tips.appendChild(text);
                        img_tips.classList.add("img_tips");
                        image.after(img_tips);
                        setTimeout(() => { img_tips.classList.add("disappear") }, 3000);
                    },
                    (error) => {
                        console.log(error);
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            const img = document.createElement("img");
                            img.classList.add("resize");
                            img.src = downloadURL;
                            img.id = pic.name;
                            image.after(img);
                        });
                    }
                );
            }
        }
        if (id === "proname") {
            setproname(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[1].style.color = "black"
            }
        }
        if (id === "otherCate") {
            setotherCate(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[3].style.color = "black"
                settag(value)
            }
        }
        if (id === "brand") {
            setbrand(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[4].style.color = "black"
            }
        }
        if (id === "prointro") {
            setprointro(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[5].style.color = "black"
            }
        }
        if (id === "proprice") {
            setproprice(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[6].style.color = "black"
            }
        }
        if (id === "stock") {
            setstock(value)
            if (value.trim().length > 0) {
                document.getElementsByTagName("label")[7].style.color = "black"
            }
        }
    }

    const other = useRef("")
    const filterBoard = (e) => {
        const { value } = e.target;
        settag(value)
        document.getElementsByTagName("label")[2].style.color = "black"
        document.querySelectorAll("select option").forEach(option => {
            option.style.backgroundColor = "aliceblue";
            option.style.color = "black";
        });
        e.target.style.backgroundColor = "rgb(103, 167, 223)"
        e.target.style.color = "white"
        if (value === "") {
            other.current.style.display = "block";
        } else {
            other.current.style.display = "none";
        }
    }

    //Upload all the data in firebase
    //Also show error when recieved error input
    const add_post = async () => {
        const 这个是二级保证 = localStorage.getItem("这个是二级保证");
        const userName = localStorage.getItem("currentLoginUser");
        const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
        const userData = userExist.docs.map(doc => doc.data());
        const dataExist = await getDocs(query(collection(cloudStore, "productData"), where("Product_Information.proname", "==", proname)));
        const productData = dataExist.docs.map(doc => doc.data());
        const image = document.querySelector(".uploadImg");
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.style.display = "none" }, 4500);
        let button = document.querySelector(".submit");
        let proID = getRandomInt(1000, 9999) + proname;

        if (userData[0]) {
            if (userData[0].officer === true && 这个是二级保证 === "true") {
                if (proname.trim().length > 0 && prointro.trim().length > 0 && proprice.trim().length > 0 && tag.trim().length > 0 && image.value.length !== 0 &&
                    stock.length > 0 && brand.trim().length > 0) {
                    if (productData.length !== 0) {
                        text = document.createTextNode("This product already exsit.");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    } else if (proname.match("%20") || proname.match(":&:")) {
                        text = document.createTextNode("For security, we are not allowed string ':&:' and '%20'.");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    } else {
                        const storageRef = ref(storage, "Product Image/" + proname + userName);
                        setpic(null)
                        setproname("")
                        setprointro("")
                        setproprice("")
                        settag("")
                        setstock("")
                        setbrand("")
                        setotherCate("")
                        document.querySelector(".resize").style.display = "none";
                        var divsToRemove = document.querySelectorAll(".resize");
                        if (divsToRemove.length > 0) {
                            for (var i = 0; i < divsToRemove.length; i++) {
                                divsToRemove[i].parentNode.removeChild(divsToRemove[i]);
                            }
                        }
                        uploadBytesResumable(storageRef, pic, metadata).then(() => { //Store img
                            getDownloadURL(storageRef).then(async (downloadURL) => {
                                const docData = {
                                    "Product_Information": {
                                        proname: proname,
                                        prointro: prointro,
                                        proprice: proprice,
                                        pic: downloadURL,
                                        tag: tag,
                                        brand: brand,
                                        author: userName,
                                        date: new Date(),
                                        proID: proID
                                    },
                                    "LeftNum": parseInt(stock),
                                    "Support": Number(0),
                                    "SellNum": Number(0),
                                    "SellPeople": Number(0),
                                    "Earn": Number(0),
                                    "OnFire": false,
                                    "offShelves": false
                                }
                                setDoc(doc(cloudStore, "productData", proID), docData).then(() => {
                                    var newDiv2 = document.createElement("div");
                                    var text = document.createTextNode(" Finished Processing");
                                    newDiv2.classList.add("tips");
                                    newDiv2.appendChild(text);
                                    newDiv2.style.color = "red"
                                    button.after(newDiv2);
                                    setTimeout(() => { window.location.reload() }, 500);
                                })
                            })
                        });
                        text = document.createTextNode("Wait for Processing. Do not Reflesh the page utill you saw the finish message");
                        newDiv.appendChild(text);
                        button.after(newDiv);
                    }
                } else {
                    text = document.createTextNode("Please fillout the important blanks.");
                    newDiv.appendChild(text);
                    button.after(newDiv);
                    if (image.value.length === 0) {
                        document.getElementsByTagName("label")[0].style.color = "red"
                    }
                    if (proname.trim().length === 0) {
                        document.getElementsByTagName("label")[1].style.color = "red"
                    }
                    if (tag.length === 0) {
                        document.getElementsByTagName("label")[2].style.color = "red"
                        document.getElementsByTagName("label")[3].style.color = "red"
                    }
                    if (brand.length === 0) {
                        document.getElementsByTagName("label")[4].style.color = "red"
                    }
                    if (prointro.length === 0) {
                        document.getElementsByTagName("label")[5].style.color = "red"
                    }
                    if (proprice.length === 0) {
                        document.getElementsByTagName("label")[6].style.color = "red"
                    }
                    if (stock.length === 0) {
                        document.getElementsByTagName("label")[7].style.color = "red"
                    }
                }
            } else {
                text = document.createTextNode("You are not officer.");
                newDiv.appendChild(text);
                button.after(newDiv);
            }
        } else {
            text = document.createTextNode("You have not signin.");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    return (
        <div id="addWelcome">
            <Navigation />
            <main>
                <div className="add">
                    <h1 className="title">Create a Product Post</h1>
                    <form>
                        <label htmlFor="propic">Product Picture: </label>
                        <input
                            className="uploadImg"
                            type="file"
                            id="propic"
                            accept="image/jpeg, image/png, image/jpg"
                            style={{ maxWidth: "360px", border: "none" }}
                            ref={imageRef}
                            onChange={(e) => { handleInputChange(e) }}
                        />
                        <br />
                        <label htmlFor="proname">Product Name: </label>
                        <input
                            type="text"
                            id="proname"
                            placeholder="Write Product Name"
                            onChange={(e) => { handleInputChange(e) }}
                            value={proname}
                        />
                        <br />
                        <label htmlFor="procate">Product Category: </label>
                        <select multiple>
                            <option value="速食米饭" onClick={(e) => filterBoard(e)}>速食米饭</option>
                            <option value="速食火锅" onClick={(e) => filterBoard(e)}>速食火锅</option>
                            <option value="速食汤面" onClick={(e) => filterBoard(e)}>速食汤面</option>
                            <option value="肉食" onClick={(e) => filterBoard(e)}>肉食</option>
                            <option value="休闲零食" onClick={(e) => filterBoard(e)}>休闲零食</option>
                            <option value="饮料" onClick={(e) => filterBoard(e)}>饮料</option>
                            <option value="手工甜点" onClick={(e) => filterBoard(e)}>手工甜点</option>
                            <option value="" onClick={(e) => filterBoard(e)}>Other</option>
                        </select>
                        <div
                            style={{ display: "none", margin: "auto", width: "60%", textAlign: "center" }}
                            ref={other}>
                            <label htmlFor="otherCate">Enter your option:</label>
                            <input type="text" id="otherCate" onChange={(e) => handleInputChange(e)} value={otherCate} />
                        </div>
                        <br />
                        <label htmlFor="brand">Product Brand: </label>
                        <input
                            type="text"
                            id="brand"
                            placeholder="Write Product Brand"
                            onChange={(e) => { handleInputChange(e) }}
                            value={brand}
                        />
                        <br />
                        <label htmlFor="prointro">Product Introduction: </label>
                        <textarea
                            className='needToBeBig'
                            type="text"
                            id="prointro"
                            placeholder="Write Product Introduction"
                            onChange={(e) => { handleInputChange(e) }}
                            value={prointro}
                        ></textarea>
                        <br />
                        <label htmlFor="proprice">Product Price: </label>
                        <input
                            type="number"
                            id="proprice"
                            placeholder="Write Product Price"
                            onChange={(e) => { handleInputChange(e) }}
                            value={proprice}
                        />
                        <br />
                        <label htmlFor="stock">Product Stock: </label>
                        <input
                            type="number"
                            id="stock"
                            placeholder="Write Product Stock"
                            onChange={(e) => { handleInputChange(e) }}
                            value={stock}
                        />
                        <div className="button submit" onClick={add_post}>Submit</div>
                    </form>
                </div>
            </main>
            <Footer />
        </div>
    );
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
} 